import { getComponentFromName } from '@folklore/utils';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useTopics from '../../hooks/useTopics';

import * as CardComponents from '../cards/taxonomies';
import PresentationList, { PresentationListProps } from './PresentationList';

const hooks = {
    default: useTopics,
};

interface TopicsListProps extends Omit<PresentationListProps<Topic>, 'cardComponent' | 'hook'> {
    hook?: string | null;
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function TopicsList({
    hook = 'default',
    cardType = null,
    cardComponent = null,
    ...props
}: TopicsListProps) {
    return (
        <PresentationList<Topic>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Horizontal)
            }
        />
    );
}

export default TopicsList;
